import React from 'react';

import { NextPageWithLayout } from 'next';

import { AppDownloadSection } from '../../../components/AppDownloadSection/AppDownloadSection';
import { Container } from '../../../components/Container/Container';
import { MetaTags } from '../../../components/MetaTags/MetaTags';
import {} from '../../../constants/constants';
import { CircleImageAndText } from '../components/CircleImageAndText';

import phoneOne from './assets/phoneOne.png';
import phoneThree from './assets/phoneThree.png';
import phoneTwo from './assets/phoneTwo.png';
import { HeaderSection } from '../components/HeaderSection';
import {
  META_FISHING_DEPTH_MAPS_TITLE,
  META_FISHING_DEPTH_MAPS_DESCRIPTION,
  META_FISHING_DEPTH_MAPS_CANONICAL,
} from '../../../constants/metadata';

export const DepthMapsPage: NextPageWithLayout = () => {
  return (
    <Container className="p-0 sm:p-0 md:p-0">
      <MetaTags
        title={META_FISHING_DEPTH_MAPS_TITLE}
        description={META_FISHING_DEPTH_MAPS_DESCRIPTION}
        link={META_FISHING_DEPTH_MAPS_CANONICAL}
      />

      <HeaderSection
        headingText=" Precise planning with depth maps"
        bodyText="Depth maps allow you to create a strategy on where to fish based on observable structures
          and the depth of the water. The depth of a water area is displayed through contoured lines
          and color, indicating how shallow or how deep a water area is. Contour lines also serve to
          help highlight underwater structures where fish may be hiding."
      />

      <CircleImageAndText
        imgSrc={phoneOne}
        imgRight
        imgAlt="Find new fishing spots in the Fishbrain app"
        headingText="Find new fishing spots"
        bodyText="Depth maps help you find prime fishing locations. Analyze the map for promising structures and depth changes."
      />

      <CircleImageAndText
        imgSrc={phoneTwo}
        imgAlt="Optimize your fishing strategy with the Fishbrain app"
        headingText="Optimize your fishing strategy"
        bodyText="We have millions of lakes covered with depth maps from both Navionics and C-maps. Depth maps help you strategize by showing where different fish are likely to be based on water depth and structures."
      />

      <CircleImageAndText
        imgSrc={phoneThree}
        imgRight
        imgAlt="Contour lines for better fishing in the Fishbrain app"
        headingText="Contour lines for better fishing"
        bodyText="Choose between transparent or Nautical mode. Close lines mean steep drop-offs; spaced lines show gradual changes, guiding you to the best spots for species like bass or walleye."
      />

      <AppDownloadSection />
    </Container>
  );
};
